import type { SVGProps } from 'react';
const SvgIconHeartFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={27} height={27} {...props}>
    <path
      fill="#E2430C"
      fillRule="evenodd"
      stroke="#E2430C"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.958 6.973A5.4 5.4 0 0 0 18.236 5.5a5.4 5.4 0 0 0-3.722 1.473l-1.014.97-1.014-.97c-2.056-1.963-5.389-1.963-7.444 0-2.056 1.964-2.056 5.149 0 7.113l1.014.969 7.444 7.112 7.444-7.112 1.014-.97A4.92 4.92 0 0 0 23.5 10.53a4.92 4.92 0 0 0-1.542-3.557"
    />
  </svg>
);
export default SvgIconHeartFilled;
